import { logEvent } from 'commons/utils/tracking';
import { MENU_PRIMARY_PINTEREST_CLICK } from 'config/trackingEvents';

export const menuPrimaryPinterestClick = (isInstalled: boolean) => {
  logEvent(MENU_PRIMARY_PINTEREST_CLICK, { isInstalled: String(isInstalled) });
};
